/* Modish Furnishing - preset quantity buttons - PDP Redo theme version (own guard + own form hook, so the IG onsite copy cannot block or override it) */
(function () {
  'use strict';
  if (window.__mfQtyPdpRedo) return;
  window.__mfQtyPdpRedo = true;

  var CONFIG = {
    options: [1, 2, 3, 4, 5, 6],
    preselect: 1,
    popular: null,
    popularLabel: 'Popular',
    label: 'How many?',
    notes: {
      stool: 'Most kitchen islands take 3 or 4',
      chair: 'Most dining tables seat 4 or 6'
    },
    seatWord: 'per seat',
    showTotalLine: true
  };

  var STYLE_ID = 'mf-qty-style-pdp-redo';
  var CSS = [
    'html.mf-qty-on .buy-buttons-block .quantity-selector,',
    'html.mf-qty-pending .buy-buttons-block .quantity-selector{display:none!important}',
    '.mf-qty{width:100%;margin:0 0 14px!important;font-family:var(--font-paragraph--family,inherit)}',
    '.mf-qty *{box-sizing:border-box}',
    '.mf-qty__total{display:block;margin:0 0 8px;font-size:15px;font-weight:500;line-height:1.3;color:var(--color-foreground,#000)}',
    '.mf-qty__each{font-weight:400;color:rgb(var(--color-foreground-rgb,0 0 0)/.55)}',
    '.mf-qty__head{display:flex!important;flex-wrap:nowrap;align-items:baseline;justify-content:space-between;gap:10px;margin:0 0 8px}',
    '.mf-qty__label{flex:0 0 auto;font-size:11px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:var(--color-foreground,#000)}',
    '.mf-qty__note{flex:1 1 auto;min-width:0;font-size:12px;font-weight:400;line-height:1.3;color:#b79c5d;text-align:right}',
    '.mf-qty__opts{display:grid!important;grid-auto-flow:column;grid-auto-columns:1fr;gap:6px}',
    '.mf-qty__btn{-webkit-appearance:none;appearance:none;display:flex!important;flex-direction:column;align-items:center;justify-content:center;gap:2px;width:100%;min-height:46px;padding:6px 2px;cursor:pointer;font-family:inherit;line-height:1;',
    'background:var(--color-variant-background,#fff);color:var(--color-variant-text,var(--color-foreground,#000));',
    'border:var(--options-border-width,1px) solid var(--color-variant-border,rgb(var(--color-foreground-rgb,0 0 0)/.2));',
    'border-radius:var(--options-border-radius,0);transition:background-color .15s ease,border-color .15s ease,color .15s ease}',
    '.mf-qty__btn:hover{border-color:var(--color-foreground,#000)}',
    '.mf-qty__btn.is-active{background:var(--color-foreground,#000)!important;border-color:var(--color-foreground,#000)!important;color:var(--color-background,#fff)!important}',
    '.mf-qty__num{font-size:15px;font-weight:500;line-height:1}',
    '.mf-qty__pop{display:block;font-size:8px;font-weight:500;letter-spacing:.08em;text-transform:uppercase;line-height:1;opacity:.8}',
    '@media screen and (max-width:749px){',
    '.mf-qty__head{gap:8px}',
    '.mf-qty__label{font-size:10px;letter-spacing:.1em}',
    '.mf-qty__note{font-size:11px}',
    '.mf-qty__opts{gap:5px}',
    '.mf-qty__btn{min-height:44px;padding:5px 1px}',
    '.mf-qty__num{font-size:14px}}'
  ].join('');

  var root = document.documentElement;
  var state = { kind: null, product: null, selected: CONFIG.preselect, lastId: null, node: null, totalEl: null };

  function log() {
    if (window.__mfQtyDebug) console.info.apply(console, ['[mf-qty]'].concat([].slice.call(arguments)));
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    (document.head || root).appendChild(s);
  }

  function handle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function kindOf(type, title) {
    var s = ((type || '') + ' ' + (title || '')).toLowerCase();
    if (/\bset\b|\bsets\b|\bbundle\b|dining table|accent chair|bench/.test(s)) return null;
    if (/barstool|bar stool|counter stool/.test(s)) return 'stool';
    if (/dining chair/.test(s)) return 'chair';
    return null;
  }

  function likelyEligible(h) {
    if (!h) return false;
    if (/(^|-)set(s)?(-|$)|dining-table|accent-chair|bench/.test(h)) return false;
    return /stool|chair/.test(h);
  }

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '£' + (cents / 100).toFixed(2);
    }
  }

  function form() {
    return document.querySelector('.pdp-redo-buy-buttons form');
  }

  function currentVariant() {
    var f = form();
    var idInput = f && f.querySelector('input[name="id"]');
    var id = idInput ? String(idInput.value) : null;
    if (!id || !state.product) return null;
    var list = state.product.variants || [];
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === id) return list[i];
    }
    return list[0] || null;
  }

  // Floating (sticky) add-to-cart bar: show the line total for the selected
  // quantity, e.g. "£660.00 for 3", instead of the single-unit price.
  function updateSticky() {
    var box = document.querySelector('sticky-add-to-cart [data-sticky-total]');
    if (!box) return;
    var wrap = box.parentNode;
    var v = currentVariant();
    if (!v || typeof v.price !== 'number') {
      box.hidden = true;
      wrap.classList.remove('has-total');
      return;
    }
    var qty = state.selected;
    var unit = window.mfIgPriceCents ? window.mfIgPriceCents(v.id, v.price) : v.price;
    var cmpBase = typeof v.compare_at_price === 'number' ? v.compare_at_price : 0;
    var cmp = window.mfIgCompareCents ? window.mfIgCompareCents(v.id, cmpBase) : cmpBase;
    var onSale = cmp > unit;

    box.querySelector('[data-sticky-total-price]').textContent = money(unit * qty);
    box.querySelector('[data-sticky-total-compare]').textContent = onSale ? money(cmp * qty) : '';
    box.querySelector('[data-sticky-total-qty]').textContent = qty > 1 ? 'for ' + qty : '';
    box.classList.toggle('is-sale', onSale);
    box.hidden = false;
    wrap.classList.add('has-total');
  }

  function updateTotal() {
    updateSticky();
    if (!state.totalEl) return;
    var v = currentVariant();
    if (!v || typeof v.price !== 'number') {
      state.totalEl.textContent = '';
      return;
    }
    var qty = state.selected;
    // Intelligems price test: use the visitor's test price when there is one.
    var unit = window.mfIgPriceCents ? window.mfIgPriceCents(v.id, v.price) : v.price;
    state.totalEl.textContent = money(unit * qty);
    if (qty > 1) {
      var each = document.createElement('span');
      each.className = 'mf-qty__each';
      each.textContent = ' · ' + money(unit) + ' ' + CONFIG.seatWord;
      state.totalEl.appendChild(each);
    }
  }

  function setQty(n) {
    state.selected = n;
    var f = form();
    var input = f && f.querySelector('input[name="quantity"]');
    if (input && String(input.value) !== String(n)) {
      input.value = String(n);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (state.node) {
      var btns = state.node.querySelectorAll('.mf-qty__btn');
      for (var i = 0; i < btns.length; i++) {
        var on = Number(btns[i].getAttribute('data-qty')) === n;
        btns[i].classList.toggle('is-active', on);
        btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }
    updateTotal();
  }

  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'mf-qty';

    if (CONFIG.showTotalLine) {
      state.totalEl = document.createElement('span');
      state.totalEl.className = 'mf-qty__total';
      state.totalEl.setAttribute('aria-live', 'polite');
      wrap.appendChild(state.totalEl);
    }

    var head = document.createElement('div');
    head.className = 'mf-qty__head';

    var label = document.createElement('span');
    label.className = 'mf-qty__label';
    label.textContent = CONFIG.label;

    var note = document.createElement('span');
    note.className = 'mf-qty__note';
    note.textContent = CONFIG.notes[state.kind] || '';

    head.appendChild(label);
    head.appendChild(note);

    var opts = document.createElement('div');
    opts.className = 'mf-qty__opts';

    CONFIG.options.forEach(function (n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mf-qty__btn';
      b.setAttribute('data-qty', String(n));
      b.setAttribute('aria-pressed', 'false');

      var num = document.createElement('span');
      num.className = 'mf-qty__num';
      num.textContent = String(n);
      b.appendChild(num);

      if (n === CONFIG.popular) {
        var pop = document.createElement('span');
        pop.className = 'mf-qty__pop';
        pop.textContent = CONFIG.popularLabel;
        b.appendChild(pop);
      }

      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setQty(n);
      });

      opts.appendChild(b);
    });

    wrap.appendChild(head);
    wrap.appendChild(opts);
    return wrap;
  }

  function mount() {
    var f = form();
    if (!f) return false;
    var row = f.querySelector('.product-form-buttons');
    var input = f.querySelector('input[name="quantity"]');
    if (!row || !input) return false;
    if (state.node && document.contains(state.node)) return true;

    injectStyle();
    state.node = build();
    row.parentNode.insertBefore(state.node, row);
    root.classList.remove('mf-qty-pending');
    root.classList.add('mf-qty-on');
    setQty(state.selected);
    log('mounted', state.kind);
    return true;
  }

  function tick() {
    if (!state.kind) return;
    mount();
    var f = form();
    var idInput = f && f.querySelector('input[name="id"]');
    var id = idInput ? String(idInput.value) : null;
    if (id && id !== state.lastId) {
      state.lastId = id;
      setQty(state.selected);
    }
    var input = f && f.querySelector('input[name="quantity"]');
    if (input && String(input.value) !== String(state.selected)) setQty(state.selected);
  }

  function start() {
    var h = handle();
    if (!h || location.pathname.indexOf('/products/') === -1) return;
    injectStyle();
    if (likelyEligible(h)) root.classList.add('mf-qty-pending');

    fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        state.product = p;
        state.kind = kindOf(p.product_type, p.title);
        if (!state.kind) {
          root.classList.remove('mf-qty-pending');
          log('skipped', p.title);
          return;
        }
        mount();
        setInterval(tick, 400);
      })
      .catch(function (err) {
        root.classList.remove('mf-qty-pending');
        log('error', err);
      });
  }

  document.addEventListener('mf:ig-prices-synced', function () { updateTotal(); });

  console.info('[mf-qty] pdp-redo theme version loaded');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
